<template>
  <v-form>
    <v-container fluid>
      <v-row>


        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="softwareSelectItems"
            v-model="item.software"
            :items="softwareSelectItems"
            :error-messages="softwareErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('profile.software.software')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <p>Format : x.x.x (1.0.0, 1.2.1, ...)</p>
          <v-text-field
            v-model="item.version"
            :error-messages="versionErrors"
            :label="$t('profile.software.version')"
            required
            @input="$v.item.version.$touch()"
            @blur="$v.item.version.$touch()"
          />
        </v-col>

      </v-row>


      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="operatingsystemSelectItems"
            v-model="item.operatingSystems"
            :items="operatingsystemSelectItems"
            :error-messages="operatingSystemsErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.operatingsystem.operatingsystems')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="softwareversionSelectItems"
            v-model="item.softwareVersion"
            :items="softwareversionSelectItems"
            :error-messages="softwareVersionErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.software.softwares')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <strong class="ml-4" >{{ $t('global.archive') }}:</strong>
          <v-switch
                v-model="item.archive"
                :error-messages="archiveErrors"
              ></v-switch>
        </v-col>
      </v-row>


    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'SoftwareVersionForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.softwareGetSelectItems();
      this.softwareversionGetSelectItems();
      this.operatingsystemGetSelectItems();
  },
  data() {
    return {
        software: null,
        version: null,
        operatingSystems: null,
        softwareVersion: null,
        archive: null,
    };
  },
  computed: {
      isLoading() {
        return (
          this.isLoading_software ||
          this.isLoading_softwareversion ||
          this.isLoading_operatingsystem
         );
      },
      ...mapFields('software', {
        softwareSelectItems: 'selectItems',
        isLoading_software : 'isLoading'
      }),
      ...mapFields('softwareversion', {
        softwareversionSelectItems: 'selectItems',
        isLoading_softwareversion : 'isLoading'
      }),
      ...mapFields('operatingsystem', {
        operatingsystemSelectItems: 'selectItems',
        isLoading_operatingsystem : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },


    softwareErrors() {
      const errors = [];

      if (!this.$v.item.software.$dirty) return errors;

      has(this.violations, 'software') && errors.push(this.violations.software);

      !this.$v.item.software.required && errors.push(this.$t('global.field_required'));


      return errors;
    },
    versionErrors() {
      const errors = [];

      if (!this.$v.item.version.$dirty) return errors;

      has(this.violations, 'version') && errors.push(this.violations.version);

      !this.$v.item.version.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    softwareVersionErrors() {
      const errors = [];
      if (!this.$v.item.softwareVersion.$dirty) return errors;
      has(this.violations, 'softwareVersion') && errors.push(this.violations.softwareVersion);
      return errors;
    },
    operatingSystemsErrors() {
      const errors = [];
      if (!this.$v.item.operatingSystems.$dirty) return errors;
      has(this.violations, 'operatingSystems') && errors.push(this.violations.operatingSystems);
      return errors;
    },
    archiveErrors() {
      const errors = [];
      if (!this.$v.item.archive.$dirty) return errors;
      has(this.violations, 'archive') && errors.push(this.violations.archive);
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        softwareGetSelectItems: 'software/fetchSelectItems'
      }),
      ...mapActions({
        operatingsystemGetSelectItems: 'operatingsystem/fetchSelectItems'
      }),
      ...mapActions({
        softwareversionGetSelectItems: 'softwareversion/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      software: {
        required,
      },
      version: {
        required,
      },
      operatingSystems: {
      },
      softwareVersion: {
      },
      archive: {

      }
    }
  }
};
</script>
